import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectPublicStudiosRetrieval = createSelector(
  [(state: AppState) => state.shared.publicStudiosRetrieval],
  ({ data, fetching }) => ({ data, fetching }),
);
